export const start_callbacks = []
export const status_callbacks = []
export const finish_callbacks = []

export default (start, status, finish) => {
    start ? start_callbacks.push(start) : null
    status ? status_callbacks.push(status) : null
    finish ? finish_callbacks.push(finish) : null
}
